/**
 * Scroll-triggered animations using Intersection Observer
 * Performance optimized: uses GPU-accelerated properties (transform, opacity)
 */
(function() {
  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Selectors for elements to animate
  var SELECTORS = [
    '.title-wrapper .title',
    '.title-wrapper .subtitle',
    '.collection__title .title',
    '.collection__description',
    '.rich-text__heading',
    '.rich-text__text',
    '.multicolumn .title',
    '.image-with-text__heading',
    '.image-with-text__text',
    '.banner__heading',
    '.banner__text',
    'section > .page-width > h1',
    'section > .page-width > h2',
    '.collapsible-content__heading'
  ].join(',');

  // Add animation class to elements
  function initAnimations() {
    var elements = document.querySelectorAll(SELECTORS);
    elements.forEach(function(el, index) {
      // Skip if already initialized
      if (el.classList.contains('animate-on-scroll')) return;

      el.classList.add('animate-on-scroll');

      // Add stagger class for siblings
      var parent = el.parentElement;
      if (parent) {
        var siblings = parent.querySelectorAll('.animate-on-scroll');
        var siblingIndex = Array.prototype.indexOf.call(siblings, el);
        if (siblingIndex > 0 && siblingIndex <= 3) {
          el.classList.add('stagger-' + siblingIndex);
        }
      }
    });
  }

  // Create Intersection Observer
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);

        // Remove will-change after animation completes for better memory
        setTimeout(function() {
          entry.target.classList.add('animation-complete');
        }, 350);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  // Observe all animated elements
  function observeElements() {
    var elements = document.querySelectorAll('.animate-on-scroll:not(.is-visible)');
    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Initialize on DOM ready
  function init() {
    initAnimations();
    observeElements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for dynamically loaded content (Shopify sections)
  document.addEventListener('shopify:section:load', function() {
    initAnimations();
    observeElements();
  });
})();
